import { selectCls, inputCls, boxCls } from './styles';
import { validateMbwayPhone } from '@/utils/mbwayValidation';

function ParcelasField({ parcelas, setParcelas, maxParcelas }) {
  if (!maxParcelas) return null;
  return (
    <div className="mt-3" data-testid="parcelas-section">
      <label className="block text-xs font-medium text-[#6B7280] mb-1">Número de Parcelas</label>
      <select data-testid="select-parcelas" value={parcelas}
        onChange={(e) => setParcelas(Number(e.target.value))} className={selectCls}>
        {Array.from({ length: maxParcelas }, (_, i) => i + 1).map((n) => (
          <option key={n} value={n}>{n} {n === 1 ? 'Mês' : 'Meses'}</option>
        ))}
      </select>
    </div>
  );
}

function MbwayPicker({ phoneNumbers, mbwayPhone, setMbwayPhone, showAddPhone, setShowAddPhone, newPhone, setNewPhone, onSavePhone }) {
  // Validação live do novo número ANTES de o utilizador clicar "Guardar".
  // Só validamos depois de o input não estar vazio (UX: não mostrar erro
  // logo no input vazio). Espelha exactamente a regra do backend para evitar
  // que o cliente carregue "Confirmar Encomenda" e leve erro do EasyPay.
  const newPhoneError = newPhone.trim() ? validateMbwayPhone(newPhone) : null;
  return (
    <div className="mt-3 border border-[#E5E7EB] rounded-lg p-3 bg-[#F9FAFB]" data-testid="mbway-section">
      <div className="flex items-center justify-between mb-2">
        <p className="text-xs font-medium text-[#6B7280]">Selecione um Telemóvel</p>
        <button onClick={() => setShowAddPhone(!showAddPhone)} data-testid="toggle-add-phone"
          className="text-xs text-[#0F1829] font-medium hover:underline">
          {showAddPhone ? 'Cancelar' : '+ Adicionar Número'}
        </button>
      </div>
      {!showAddPhone ? (
        <select data-testid="select-mbway-phone" value={mbwayPhone}
          onChange={(e) => setMbwayPhone(e.target.value)} className={selectCls}>
          <option value="">Selecione um telemóvel</option>
          {phoneNumbers.map((p) => <option key={p.Id} value={p.Descricao}>{p.Descricao}</option>)}
        </select>
      ) : (
        <div className="space-y-2">
          <label className="block text-xs text-[#6B7280]">Adicionar Número de Telemóvel</label>
          <input data-testid="new-phone-input" type="tel" value={newPhone}
            onChange={(e) => setNewPhone(e.target.value)}
            placeholder="351 912345678"
            className={`${inputCls} ${newPhoneError ? 'border-red-400 focus:border-red-500 focus:ring-red-200' : ''}`}
            aria-invalid={!!newPhoneError}
            aria-describedby={newPhoneError ? 'new-phone-error' : 'new-phone-hint'} />
          {newPhoneError ? (
            <p id="new-phone-error" data-testid="new-phone-error" className="text-xs text-red-600">
              {newPhoneError}
            </p>
          ) : (
            <p id="new-phone-hint" className="text-xs text-[#9CA3AF]">Formato: indicativo número (ex: 351 912345678)</p>
          )}
          <button onClick={onSavePhone} disabled={!newPhone.trim() || !!newPhoneError} data-testid="save-phone-btn"
            className="w-full py-2 text-xs font-medium bg-[#0F1829] text-white rounded-md hover:bg-[#001f6e] disabled:opacity-40 transition-colors">
            Guardar Número de Telemóvel
          </button>
        </div>
      )}
    </div>
  );
}

export default function PaymentSection({
  selectablePaymentMethods, selectedPayment, onChangePayment,
  isInstallments, parcelas, setParcelas, maxParcelas,
  isPhonePayment, phoneNumbers, mbwayPhone, setMbwayPhone,
  showAddPhone, setShowAddPhone, newPhone, setNewPhone, onSavePhone,
}) {
  return (
    <div className={boxCls} data-testid="payment-section">
      <p className="text-xs font-semibold text-[#111827] mb-2">Pagamento</p>
      <select data-testid="select-payment" value={selectedPayment}
        onChange={(e) => onChangePayment(e.target.value)} className={selectCls}>
        <option value="">Selecione um tipo de pagamento</option>
        {selectablePaymentMethods.map((m) => (
          <option key={m.Id} value={m.Id} disabled={!!m._disabled}>{m.Descricao}</option>
        ))}
      </select>
      {isInstallments && (
        <ParcelasField parcelas={parcelas} setParcelas={setParcelas} maxParcelas={maxParcelas} />
      )}
      {isPhonePayment && (
        <MbwayPicker
          phoneNumbers={phoneNumbers} mbwayPhone={mbwayPhone} setMbwayPhone={setMbwayPhone}
          showAddPhone={showAddPhone} setShowAddPhone={setShowAddPhone}
          newPhone={newPhone} setNewPhone={setNewPhone} onSavePhone={onSavePhone}
        />
      )}
    </div>
  );
}
